import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useGlobalSearch } from "./context";

// Paths where search shortcuts should be disabled (like during gameplay)
const DISABLED_SEARCH_PATHS = [
  "/rise-of-realms/play/", // Disable during active gameplay
];

/**
 * Component to listen for global search keyboard shortcuts.
 * Must be rendered inside the Router context.
 */
const SearchShortcutListener: React.FC = () => {
  const { openSearch } = useGlobalSearch();
  const location = useLocation();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Skip if focus is in an input element
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement ||
        e.target instanceof HTMLSelectElement
      ) {
        return;
      }

      // Check if we're on a disabled path (like gameplay screen)
      const isDisabled = DISABLED_SEARCH_PATHS.some((path) =>
        location.pathname.includes(path)
      );

      if (isDisabled) {
        return;
      }

      console.log("key pressed", e.key);

      // Check if the key is cmd+k or ctrl+k
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        openSearch();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [openSearch, location.pathname]);

  // This component doesn't render anything visual
  return null;
};

export default SearchShortcutListener;
